import React, { useEffect } from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import ItineraryForm from "./_form";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";

// labels
import {
    LB_ACTIONS, LB_ACTIVE,
    LIST, NO_DATA_FOUND
} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";


// actions


// services
import ItineraryFilters from "./_filters";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {itineraryService} from "../../../jwt/_services/eventx/ItineraryService";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import {setViewMode} from "../../../redux/actions/genericActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";


const ItineraryList = (props) => {
    // const { app, udn } = props.mainProps
    // const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    // const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    // asignar los valores por default del filtro
    useEffect( () => {
        if(!app?.fbDataBase?.id || !udn.id || filter)
            return

        props.setFilter(path , {
            onlyRegistered : true,
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                date:null ,
                udn : { id: udn.id }
            }
        } )
    }, [ app, udn ]);



    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, itineraryService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);



    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path,  tableChangeParams.sizePerPage, currentIndex );
    };


    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( ItineraryForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);
        ModalFormContainer(ItineraryForm, {path,  data, Form: ItineraryForm })
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: itineraryService
        } );
    };

    const handleStatusChange = async (id, data, _status) => {
        genericIndexedActions.update(path, itineraryService, id, {
            fbDataBase: {id: app?.fbDataBase?.id},
            item: {...data, status: _status, id: id}
        })
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>


    const activeFormatter = cell => <ActiveFormatter active={cell} />



    const columns = [
        {
            dataField: 'id',
            headerStyle: { width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: `UID`,
            headerStyle: {width: '200px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'activityName',
            text: 'Evento / Actividad'
        }, {
            dataField: 'categoryName',
            text: 'Genero / Categoria'
        }, {
            dataField: 'placeName',
            text: 'Foro / Lugar'
        }, {
            dataField: 'date',
            text: 'Fecha',
            headerStyle: {width: '100px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'timeStart',
            text: 'Desde',
            headerStyle: {width: '100px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'timeEnd',
            text: 'Hasta',
            headerStyle: {width: '100px'},
            headerAlign: 'center',
            align:'center',
        }, {
            dataField: 'status',
            text: "Activo",
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '80px'},
            formatter: (cell, row) => <GenericSwitch
                id={ row?.id }
                initialState={ row?.status }
                onChange={ handleStatusChange }
            />
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerStyle: {width: '250px'},
            headerAlign: 'center',
            align:'center',
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <ItineraryFilters path={path}/>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
})
export default connect(mapStateToProps, mapActionsToProps)(ItineraryList)